import { Box, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import styles from "../../../styles/pages/copywriter-searchresult.module.scss";
import SearchCard from "../../../components/SearchCard/SearchCard";
import { getUtcDate, getUtcTime } from "../../../lib/functions/utils.lib";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import { useInfiniteQuery, useQuery } from "react-query";
import Magnifying from "../../../../src/public/assets/images/icon-magnifying.svg";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { useAppSelector } from "../../../hooks/useAppSelector";
import CopyWriterDashboardWrapper from "../../../layout/wrapper/CopyWriterDashboardWrapper";
import { searchDataCallCopywriters } from "../../../api/functions/copywritersDashboard.api";

const CopywriterSearchResult = () => {
  const { query } = useAppSelector((s) => s.searchQuerySlice);
  console.warn("queryCopywriters", query);
  const [previousData, setPreviousData] = useState(null);
  const [searchData, setSearchData] = useState("");

  /*   const { data, isLoading, isError } = useQuery(["search", query], () => {
      if (query.length > 1) {
        return searchDataCall(query);
      }
    });
   */
  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteQuery({
      queryKey: ["search", query],
      queryFn: ({ pageParam = 1 }) => {
        // console.warn(pageParam, "pageParam");
        if (query.length !== 0) {
          return searchDataCallCopywriters(query, pageParam);
        }
      },
      keepPreviousData: true,
      enabled: !!query,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0]?.current_page <
          allPages[0]?.last_page
        ) {
          return allPages[allPages.length - 1 || 0]?.current_page + 1;
        } else {
          return undefined;
        }
      },
    });
  // console.warn("data", data);
  const searchResultData = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat?.data, ...item?.data] };
    });
    return dat;
  }, [data]);

  console.warn("searchResultData", searchResultData);

  useEffect(() => {
    if (searchResultData) {
      setSearchData(query);
    }
  }, [searchResultData]);

  // console.warn("headerSearch", data);
  // console.warn("previousData", previousData);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index - 1);
    console.warn("index", index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <CopyWriterDashboardWrapper>
      <ApiLoader loading={isLoading} />
      <Box className="main_body">
        <Box className={styles.pageSearchResult}>
          {searchResultData?.data?.length > 0 ? (
            <>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.resultHeading}
              >
                <Typography variant="h2">
                  Search results for “{searchData}”
                </Typography>
                <Typography variant="caption">
                  {searchResultData?.total}
                  {searchResultData?.total > 1 ? "results" : "result"}
                </Typography>
              </Stack>
              <Box className={styles.scrollbodyPaper}>
                <Paper elevation={0}>
                  <InfiniteScroll
                    dataLength={searchResultData?.data?.length}
                    next={fetchNextPage}
                    height={`calc(100vh - 160px)`}
                    hasMore={hasNextPage}
                    loader={<h4>Loading... </h4>}
                    className={styles.infiniteScroll}
                  >
                    {searchResultData?.data?.map((item, index) => {
                      return (
                        <>
                          <SearchCard
                            id={index}
                            figImg={item?.thumbnail}
                            vsidText={item?.vsid}
                            submissionDate={`${getUtcDate(
                              item?.created_at
                            )}${getUtcTime(item?.created_at)}`}
                            submitterName={
                              item?.first_name || item?.last_name
                                ? `${item?.first_name} ${item?.last_name}`
                                : "N/A"
                            }
                            emailAddress={item?.email}
                            acquisitor={item?.acquisitor}
                            videoStatus={item?.videoStatus}
                            videoDate={`Since ${getUtcDate(
                              item?.status_changed_at
                            )}${getUtcTime(item?.status_changed_at)}`}
                            // type={item?.type}
                            user={item?.user}
                            item={item}
                            hoveredIndex={hoveredIndex}
                            handleMouseEnter={handleMouseEnter}
                            handleMouseLeave={handleMouseLeave}
                          />
                        </>
                      );
                    })}
                  </InfiniteScroll>
                </Paper>
              </Box>
            </>
          ) : (
            <>
              <Paper elevation={0} className={styles.nodataFound}>
                <figure>
                  <img src={Magnifying} alt="" />
                </figure>
                <Typography variant="body1">
                  We couldn't find any matching videos for{" "}
                  <strong>{query}</strong>.
                </Typography>
              </Paper>
            </>
          )}
        </Box>
      </Box>
    </CopyWriterDashboardWrapper>
  );
};

export default CopywriterSearchResult;
